import { authApiService } from '@/api/authApiService';
import { UpdateInvitedUserPayloadType, UpdateInvitedUserResponseType } from '@/api/types';
import { ApiResponseType } from '@/types/sharedTypes';

export type UpdateExecutorResponseType = UpdateInvitedUserResponseType & {
  id: string;
};

export const updateExecutorApi = (
  wireId: string,
  executorId: string,
  data: UpdateInvitedUserPayloadType
): Promise<ApiResponseType<UpdateExecutorResponseType>> => {
  const uri = `/organization/wires/${wireId}/executors/${executorId}/`;

  return authApiService.PATCH(uri, data);
};
